import { post as $post, get as $get } from './core/fetch';


export const change_password = (pwd) => $post('/update-user', pwd);
export const change_lng = (lng) => $post('/update-user', lng);
export const change_report_settings = (settings) => $post('/update-user', settings);
export const update_limits = (limits) => $post('/update-organization-limits', limits);
export const ui_check = (page) => $get(`/ui-check/${page}`);

